import { useSelector } from 'react-redux';

import type { RootState } from '../../../store';

export const useClaimsSelectors = () => {
  const user = useSelector((state: RootState) => state.auth.user);
  const {
    providerLicensesMapping,
    providerPayorCredentialsMapping,
    providerLicensesLoading,
    providerPayorCredentialsLoading,
    providerLicensesErrors,
    providerPayorCredentialsErrors,
  } = useSelector((state: RootState) => state.providers);
  const {
    allClientsList: clients = [],
    loading: clientsLoading,
    selectedClientPlans,
  } = useSelector((state: RootState) => state.clients);
  const { list: serviceCodes, loading: serviceCodesLoading } = useSelector(
    (state: RootState) => state.serviceCodes,
  );
  const { sessionsWithClaimStatus, loading: sessionsLoading } = useSelector(
    (state: RootState) => state.sessions,
  );
  const { supervisionsWithClaimStatus: clientSNWithClaimStatus, loading: clientSNLoading } =
    useSelector((state: RootState) => state.clientSupervisions);
  const { supervisionsWithClaimStatus: parentSNWithClaimStatus, loading: parentSNLoading } =
    useSelector((state: RootState) => state.parentSupervision);
  const { supervisionsWithClaimStatus: gpsnWithClaimStatus } = useSelector(
    (state: RootState) => state.groupParentSupervision,
  );
  const {
    assessmentsWithClaimStatus,
    loading: assessmentsLoading,
    assistingAssessmentsWithClaimStatus,
    loading: assistingAssessmentsLoading,
  } = useSelector((state: RootState) => state.clientAssessment);
  const { loading: claimsLoading, claimPreview } = useSelector((state: RootState) => state.claims);

  return {
    user,
    providerLicensesMapping,
    providerPayorCredentialsMapping,
    providerLicensesLoading,
    providerPayorCredentialsLoading,
    providerLicensesErrors,
    providerPayorCredentialsErrors,
    clients,
    clientsLoading,
    serviceCodes,
    serviceCodesLoading,
    sessionsWithClaimStatus,
    sessionsLoading,
    clientSNWithClaimStatus,
    clientSNLoading,
    parentSNWithClaimStatus,
    parentSNLoading,
    gpsnWithClaimStatus,
    assessmentsWithClaimStatus,
    assessmentsLoading,
    assistingAssessmentsWithClaimStatus,
    assistingAssessmentsLoading,
    claimsLoading,
    claimPreview,
    selectedClientPlans,
  };
};
